import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { makeStyles, Typography, TextField } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { useIntl } from 'react-intl'
import { CapeeshColors } from '../../../assets/ColorPalette'
import { studentActions } from '../../../_state/actions'
import { studentScreenMessages } from '../StudentScreen.i18n.Messages'

const useStyles = makeStyles((theme) => ({
    dialog: {
        padding: 16,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        minWidth: 320,
    },
    submitButton: {
        backgroundColor: CapeeshColors.BlueBright || '#2196f3',
        color: 'white',
        borderRadius: 4,
        '&:hover': {
            backgroundColor: '#1565c0',
        },
    },
    closeButton: {
        color: CapeeshColors.Gray1 || '#8E8E93',
    },
    successText: {
        color: '#4caf50',
        textAlign: 'center',
        fontSize: 14,
        marginTop: 8,
    },
}))

const StudentSetPasswordDialog = ({ open, onClose, student, dispatch }) => {
    const classes = useStyles()
    const intl = useIntl()

    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        if (!open) {
            setNewPassword('')
            setConfirmPassword('')
            setError('')
        }
    }, [open])

    useEffect(() => {
        if (student.passwordSetSuccess && open) {
            setNewPassword('')
            setConfirmPassword('')
            setError('')
        }
    }, [student.passwordSetSuccess])

    const handleSubmit = () => {
        setError('')

        if (!newPassword || newPassword.length < 6) {
            setError(intl.formatMessage(studentScreenMessages.passwordTooShort))
            return
        }
        if (newPassword !== confirmPassword) {
            setError(intl.formatMessage(studentScreenMessages.passwordsDoNotMatch))
            return
        }

        dispatch(studentActions.setPassword(newPassword))
    }

    return (
        <Dialog onClose={onClose} open={open} maxWidth="sm">
            <div className={classes.dialog}>
                <DialogTitle style={{ display: 'flex', justifyContent: 'center' }}>
                    {intl.formatMessage(studentScreenMessages.setPassword)}
                </DialogTitle>
                <DialogContent>
                    <div className={classes.content}>
                        <Typography style={{ fontSize: 14, color: '#555', textAlign: 'center' }}>
                            {intl.formatMessage(studentScreenMessages.setPasswordDescription)}
                        </Typography>

                        {student.passwordSetSuccess ? (
                            <Typography className={classes.successText}>
                                {intl.formatMessage(studentScreenMessages.passwordSetSuccess)}
                            </Typography>
                        ) : (
                            <React.Fragment>
                                <TextField
                                    label={intl.formatMessage(studentScreenMessages.newPassword)}
                                    type="password"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    disabled={student.isSettingPassword}
                                />
                                <TextField
                                    label={intl.formatMessage(studentScreenMessages.confirmPassword)}
                                    type="password"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    disabled={student.isSettingPassword}
                                    onKeyPress={(e) => { if (e.key === 'Enter') handleSubmit() }}
                                />
                                {error && (
                                    <Typography style={{ color: '#f44336', fontSize: 13 }}>
                                        {error}
                                    </Typography>
                                )}
                            </React.Fragment>
                        )}
                    </div>
                </DialogContent>
                <DialogActions style={{ marginTop: 10, gap: 4, justifyContent: 'center' }}>
                    {!student.passwordSetSuccess && (
                        <Button
                            className={classes.submitButton}
                            onClick={handleSubmit}
                            disabled={student.isSettingPassword}
                        >
                            {student.isSettingPassword
                                ? intl.formatMessage(studentScreenMessages.saving)
                                : intl.formatMessage(studentScreenMessages.setPassword)}
                        </Button>
                    )}
                    <Button className={classes.closeButton} onClick={onClose}>
                        {intl.formatMessage(studentScreenMessages.close)}
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    )
}

const mapStateToProps = (state) => ({
    student: state.student,
})

export default connect(mapStateToProps)(StudentSetPasswordDialog)
